/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Input } from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';

import { InputProps } from 'interfaces/otherInterface/dynamicInput';

const isNotEmpty = (obj: any) => Object.keys(obj).length > 0;

const InputAmount = ({
  inputs,
  renderInputField,
  countries,
  loadingCountry,
  defaultCountry,
  showInputAmount,
  bothCheckAmountTypeAreTrue,
  fixedInputValue,
  onChangeFixedInputValue,
  noAmountTypeSpecified,
  shouldDisableAmountField,
  showAmountField,
  currency,
}: {
  inputs: InputProps[];
  renderInputField: any;
  countries: any;
  loadingCountry: any;
  defaultCountry: any;
  showInputAmount: boolean;
  currency?: string;
  bothCheckAmountTypeAreTrue: boolean;
  fixedInputValue: any;
  onChangeFixedInputValue: any;
  noAmountTypeSpecified: any;
  shouldDisableAmountField: boolean;
  showAmountField: boolean;
}) => {
  const { translate } = useLanguage();
  return (
    <div key="dynamic-input">
      {isNotEmpty(inputs?.[0] || {}) &&
        inputs?.map((field: any, index: number) => (
          <Form.Item
            key={index}
            label={translate(field.label)}
            required={field?.required}
            rules={[{ required: field?.required }]}
            name={field?.key}
            className="custom-input-margin__bottom"
            hidden={field?.hidden}
            valuePropName={
              field?.type !== 'checkbox' && field?.type !== 'file'
                ? undefined
                : field?.multi || field?.options?.length > 0
                  ? 'value'
                  : field?.key === 'file'
                    ? 'fileList'
                    : 'checked'
            }
            getValueFromEvent={
              field?.type === 'file'
                ? (e) => {
                    return e?.fileList?.map(
                      (file: any) => file.url || '',
                    );
                  }
                : undefined
            }
          >
            {renderInputField(
              field,
              index,
              countries,
              loadingCountry,
              defaultCountry,
            )}
          </Form.Item>
        ))}

      {showInputAmount && (
        <Form.Item
          label={translate('Amount')}
          style={{ marginBottom: '10px' }}
          rules={[{ required: true }]}
        >
          {bothCheckAmountTypeAreTrue ? (
            <Input
              size="large"
              name="Amount"
              disabled={bothCheckAmountTypeAreTrue}
              placeholder={translate('Amount')}
              value={fixedInputValue}
              onChange={onChangeFixedInputValue}
              suffix={currency}
            />
          ) : (
            <>
              {shouldDisableAmountField && (
                <Input
                  size="large"
                  name="Amount"
                  disabled={shouldDisableAmountField}
                  placeholder={translate('Amount')}
                  value={fixedInputValue}
                  onChange={onChangeFixedInputValue}
                  suffix={currency}
                />
              )}
              {showAmountField && (
                <Input
                  size="large"
                  name="Amount"
                  placeholder={translate('Amount')}
                  value={fixedInputValue}
                  onChange={onChangeFixedInputValue}
                  suffix={currency}
                />
              )}
            </>
          )}

          {noAmountTypeSpecified && (
            <Input
              size="large"
              name="Amount"
              placeholder={translate('Amount')}
              value={fixedInputValue}
              onChange={onChangeFixedInputValue}
              suffix={currency}
            />
          )}
        </Form.Item>
      )}
    </div>
  );
};

export default InputAmount;
